import { render } from "./HeroSection.vue?vue&type=template&id=2cb2a736&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=2cb2a736&scoped=true&lang=sass"
import "./HeroSection.vue?vue&type=style&index=1&id=2cb2a736&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb2a736"]])

export default __exports__